// Date / price formatters shared across the site.

const DAYS_PL_SHORT = ["ndz", "pn", "wt", "śr", "czw", "pt", "sob"];
const DAYS_EN_SHORT = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const DAYS_UK_SHORT = ["нд", "пн", "вт", "ср", "чт", "пт", "сб"];
const MONTHS_PL = ["sty","lut","mar","kwi","maj","cze","lip","sie","wrz","paź","lis","gru"];
const MONTHS_EN = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

function parseIsoDate(iso) {
  // YYYY-MM-DD -> local Date
  const [y, m, d] = iso.split("-").map((n) => parseInt(n, 10));
  return new Date(y, m - 1, d);
}

export function formatDateRange(startIso, endIso, lang = "pl") {
  const s = parseIsoDate(startIso);
  const e = parseIsoDate(endIso);
  const days = lang === "uk" ? DAYS_UK_SHORT : lang === "en" ? DAYS_EN_SHORT : DAYS_PL_SHORT;

  const pad = (n) => String(n).padStart(2, "0");
  const fmt = (d) => `${pad(d.getDate())}.${pad(d.getMonth() + 1)} (${days[d.getDay()]})`;
  const year = e.getFullYear() !== s.getFullYear() ? ` ${e.getFullYear()}` : ` ${e.getFullYear()}`;
  return `${fmt(s)} – ${fmt(e)}${year}`;
}

export function formatPrice(value, currency = "zł") {
  if (value == null || isNaN(value)) return "";
  const n = Number(value);
  const integer = Math.floor(n);
  const rest = n - integer;
  const int = integer.toLocaleString("pl-PL").replace(/,/g, " ");
  if (rest > 0) {
    const cents = Math.round(rest * 100).toString().padStart(2, "0");
    return `${int},${cents} ${currency}`;
  }
  return `${int} ${currency}`;
}
